import { Sponsor } from "../../data/interfaces";

// -----------------------------------------------------------------
// I n i t i a l   S t a t e
// -----------------------------------------------------------------
const INITIAL_STATE = {
  sponsors: [],
  loading: false,
  error: false,
};

// -----------------------------------------------------------------
// S t a t e   I n t e r f a c e
// -----------------------------------------------------------------
export interface SponsorsState {
  loading: boolean;
  error: boolean;
  sponsors: Sponsor[];
}

// -----------------------------------------------------------------
// A c t i o n   s w i t c h e r
// -----------------------------------------------------------------
export default (state: SponsorsState = INITIAL_STATE, action: any): SponsorsState => {
  switch (action.type) {
    case "SPONSORS_LIST_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "SPONSORS_LIST_LOADED":
      let data = state.sponsors ? state.sponsors : [];

      return {
        ...state,
        loading: false,
        error: false,
        sponsors: [...data, ...action.payload.sponsors],
      };
    case "SPONSORS_LIST_ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};
